(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const initializeGalleries = (scope = document) => {
      scope.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
        if (gallery.dataset.galleryInitialized === 'true') return;
        gallery.dataset.galleryInitialized = 'true';

        const mediaItems = gallery.querySelectorAll('[data-product-media]');
        const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');

        thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            const targetId = thumbnail.dataset.galleryTarget;
            mediaItems.forEach((media) => {
              media.hidden = media.dataset.productMedia !== targetId;
            });
            thumbnails.forEach((item) => {
              const isActive = item === thumbnail;
              item.classList.toggle('is-active', isActive);
              item.setAttribute('aria-pressed', String(isActive));
            });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeGalleries(), { once: true });
    } else {
      initializeGalleries();
    }
    document.addEventListener('shopify:section:load', (event) => initializeGalleries(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squishy-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
      const slides = Array.from(carousel.querySelectorAll('.squishy-hero__slide'));
      const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
      const pauseButton = carousel.querySelector('[data-hero-pause]');
      const interval = Math.max(Number(carousel.dataset.interval) || 5000, 3000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let index = 0;
      let timer;
      let userPaused = reduceMotion;

      const show = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (!userPaused && slides.length > 1) timer = window.setInterval(() => show(index + 1), interval);
      };
      const updatePauseButton = () => {
        pauseButton.setAttribute('aria-pressed', String(userPaused));
        pauseButton.setAttribute('aria-label', userPaused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
        pauseButton.querySelector('.squishy-hero__pause-icon').textContent = userPaused ? '▶' : 'Ⅱ';
      };

      carousel.querySelector('[data-hero-prev]').addEventListener('click', () => { show(index - 1); start(); });
      carousel.querySelector('[data-hero-next]').addEventListener('click', () => { show(index + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); start(); }));
      pauseButton.addEventListener('click', () => { userPaused = !userPaused; updatePauseButton(); start(); });
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', (event) => { if (!carousel.contains(event.relatedTarget)) start(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });

      updatePauseButton();
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
